import { head, map } from "../Docs/fable_modules/fable-library.3.7.1/Array.js";
import { createObj, equals, comparePrimitives, max, round } from "../Docs/fable_modules/fable-library.3.7.1/Util.js";
import { Table_onStateChange_Z4395D14A } from "./Table.fs.js";
import { class_type } from "../Docs/fable_modules/fable-library.3.7.1/Reflection.js";
import { ColumnResizeMode, ColumnResizeMode_toString_21C97CDE } from "./Types.fs.js";
import { ColumnPinningPosition__asString } from "./Column.fs.js";
import { Header_getLeafHeaders_315F98D7 } from "./Header.fs.js";

function calculateColumnSizing(deltaPercentage, old) {
    return map((arr) => {
        const c = arr[0];
        const h = arr[1];
        return [c, round(max(comparePrimitives, h + (h * deltaPercentage), 0) * 100) / 100];
    }, old.columnSizingStart);
}

function calculateChange(applyChange, event, table) {
    table._obj.setOptions((prev) => {
        const old = prev.state.columnSizingInfo;
        let newColumnSizing;
        if (event == null) {
            newColumnSizing = calculateColumnSizing(old.deltaPercentage, old);
        }
        else {
            const e = event;
            const deltaOffset = e.clientX - (equals(old.startOffset, null) ? 0 : old.startOffset);
            const deltaPercentage = max(comparePrimitives, deltaOffset / (equals(old.startSize, null) ? 0 : old.startSize), -0.999999);
            const delta = {
                deltaOffset: deltaOffset,
                deltaPercentage: deltaPercentage,
            };
            const columnSizing = calculateColumnSizing(deltaPercentage, old);
            const newState = { ...old, ...delta };
            prev.state.columnSizingInfo = newState;
            newColumnSizing = columnSizing;
        }
        prev.state.columnSizing = (applyChange ? ({ ...prev.state.columnSizing, ...createObj(newColumnSizing) }) : prev.state.columnSizing);
        return { ...prev, ...table._obj.options, onStateChange: Table_onStateChange_Z4395D14A(table) };
    });
    return table;
}

export class Column {
    constructor() {
    }
}

export function Column$reflection() {
    return class_type("Feliz.TanStack.Table.Sizing.Column", void 0, Column);
}

export function Column_getCanResize_Z2685F962(column) {
    return column._obj.getCanResize();
}

export function Column_getSize_Z2685F962(column) {
    return column.getSize();
}

export function Column_getIsResizing_Z2685F962(column) {
    return column.getIsResizing();
}

export function Column_resetSize_Z2685F962(column) {
    column.resetSize();
}

export class Table {
    constructor() {
    }
}

export function Table$reflection() {
    return class_type("Feliz.TanStack.Table.Sizing.Table", void 0, Table);
}

export function Table_getDeltaOffset_Z4395D14A(table) {
    return (table._obj.getState()).columnSizingInfo.deltaOffset;
}

export function Table_setColumnSizingMode(sizingMode, table) {
    table._obj.setOptions((prev) => {
        prev.columnResizeMode = ColumnResizeMode_toString_21C97CDE(sizingMode);
        return { ...prev, ...table._obj.options, onStateChange: Table_onStateChange_Z4395D14A(table) };
    });
    return table;
}

export function Table_resetColumnSizing(defaultState, table) {
    table._obj.resetColumnSizing(defaultState);
}

export function Table_resetHeaderSizeInfo(defaultState, table) {
    table._obj.resetHeaderSizeInfo(defaultState);
}

export function Table_getTotalSize_Z4395D14A(table) {
    return table._obj.getTotalSize();
}

export function Table_getLeftTotalSize_Z4395D14A(table) {
    return table._obj.getLeftTotalSize();
}

export function Table_getCenterTotalSize_Z4395D14A(table) {
    return table._obj.getCenterTotalSize();
}

export function Table_getRightTotalSize_Z4395D14A(table) {
    return table._obj.getRightTotalSize();
}

export class Header {
    constructor() {
    }
}

export function Header$reflection() {
    return class_type("Feliz.TanStack.Table.Sizing.Header", void 0, Header);
}

export function Header_getSize_315F98D7(header) {
    return header.getSize();
}

export function Header_getStart(header, position) {
    const posStr = ColumnPinningPosition__asString(position);
    return (header.getStart(posStr)) | 0;
}

export function Header_endResize_Z4395D14A(table) {
    const table_1 = calculateChange(table._obj.options.columnResizeMode === ColumnResizeMode_toString_21C97CDE(new ColumnResizeMode(1)), void 0, table);
    table_1._obj.setOptions((prev) => {
        const options = {};
        prev.state.columnSizingInfo = options;
        return { ...prev, ...table_1._obj.options, onStateChange: Table_onStateChange_Z4395D14A(table_1) };
    });
    return table_1;
}

export function Header_resizeHandler(event, header, table) {
    const column = header.column;
    const startSize = Header_getSize_315F98D7(header) | 0;
    const leafHeaders = Header_getLeafHeaders_315F98D7(header);
    const columnSizingStart = (leafHeaders.length !== 0) ? map((h) => [h.column.id, Column_getSize_Z2685F962(h.column)], leafHeaders) : [[header.column.id, Column_getSize_Z2685F962(header.column)]];
    const clientX = equals(event.type, "touchstart") ? round(head(event.touches).clientX) : event.clientX;
    table._obj.setOptions((prev) => {
        const options = {
            startOffset: clientX,
            startSize: startSize,
            deltaOffset: 0,
            deltaPercentage: 0,
            columnSizingStart: columnSizingStart,
            isResizingColumn: column.id,
        };
        prev.state.columnSizingInfo = options;
        const options_1 = table._obj.options;
        const onTableStateChange = Table_onStateChange_Z4395D14A(table);
        return { ...prev, ...options_1, onStateChange: onTableStateChange };
    });
    return (event_1) => {
        if (event_1.cancelable) {
            event_1.preventDefault();
            event_1.stopPropagation();
        }
        return calculateChange(table._obj.options.columnResizeMode === ColumnResizeMode_toString_21C97CDE(new ColumnResizeMode(0)), event_1, table);
    };
}

//# sourceMappingURL=Sizing.fs.js.map
